export var QuantityContent;
(function (QuantityContent) {
    QuantityContent["Gallons"] = "Gallons";
    QuantityContent["Longtons"] = "Longtons";
    QuantityContent["Shorttons"] = "Shorttons";
    QuantityContent["MetrTons"] = "Metr. tons";
    QuantityContent["Liter"] = "Liter";
    QuantityContent["Others"] = "Others";
})(QuantityContent || (QuantityContent = {}));
//# sourceMappingURL=QuantityContent.js.map